import Axios from '@/api/http'

/**
 * 请求我的发起数据
 * */
export function getuserapprovinglist (query) {
  return Axios({
    method: 'post',
    url: '/openapi/getuserapprovinglist',
    data: query
  })
}

export function getapproving (query) {
  return Axios({
    method: 'post',
    url: '/api/getapproving',
    data: query
  })
}

/**
 * 不知道请求什么的
 * */
export function updateuserccapproving (query) {
  return Axios({
    method: 'post',
    url: '/openapi/updateuserccapproving',
    data: query
  })
}

/**
 * 获取抄送已读未读列表(尾部)
 * */
export function openapiGetuserccapprovallist (query) {
  return Axios({
    method: 'post',
    // url: '/openapi/getuserccapprovallist',
    url: '/openapi/getuserccapprovalhandlelist',
    data: query
  })
}

/**
 * 传阅接口
 * */
export function openapiApprovingdistribute (query) {
  return Axios({
    method: 'post',
    url: '/openapi/approvingdistribute',
    data: query
  })
}

/**
 * 头部已读未读
 * */
export function openapiGetapprovinguser (query) {
  return Axios({
    method: 'post',
    url: '/openapi/getapprovinguser',
    data: query
  })
}

/**
 * 获取审批按钮（不带参数）
 * */
export function apiGetapprovalselection (query) {
  return Axios({
    method: 'post',
    url: '/api/getapprovalselection',
    data: query
  })
}

/**
 * 获取模板数据 用 approvingId 获取
 * */
export function openapiGetapproval (query) {
  return Axios({
    method: 'post',
    url: '/openapi/getapproval',
    data: query
  })
}

/**
 * 修改某个控件数据
 * */
export function updateapprovingfeilds (query) {
  return Axios({
    method: 'post',
    url: 'openapi/updateapprovingfeilds',
    data: query
  })
}

/**
 * 判断当前用户有没有权限
 * */
export function getapprovallimit (query) {
  return Axios({
    method: 'post',
    url: 'openapi/getapprovallimit',
    data: query
  })
}

/**
 * 自定义详情页获取数据 用 approvingId 获取
 * */
export function getoherappvaldatalist (query) {
  return Axios({
    method: 'post',
    url: '/openapi/getoherappvaldatalist',
    data: query
  })
}

/**
 * 获取列表数据
 * */
export function openapiGetapprovalreserve (query) {
  return Axios({
    method: 'post',
    url: '/openapi/getapprovalreserve',
    data: query
  })
}

/**
 * 获取列表数据
 * */
export function getlinkeddatalist (query) {
  return Axios({
    method: 'post',
    url: '/api/getlinkeddatalist',
    data: query
  })
}

/**
 * 告知已读
 * */
export function openapiUpdateuserccapproving (query) {
  return Axios({
    method: 'post',
    url: '/openapi/updateuserccapproving',
    data: query
  })
}
/**
 * 告知已读
 * */
export function updateappread (query) {
  return Axios({
    method: 'post',
    url: '/openapi/updateappread',
    data: query
  })
}

/**
 * 提交验证是否重复
 * */
export function checkdataunique (query) {
  return Axios({
    method: 'post',
    url: '/openapi/checkdataunique',
    data: query
  })
}

/**
 * 手动上链
 * */
export function addcochain (query) {
  return Axios({
    method: 'post',
    url: '/openapi/addcochain',
    data: query
  })
}
/**
 * 填写统计
 */
export function getunfilleduserinfo (query) {
  return Axios({
    method: 'post',
    url: '/openapi/getunfilleduserinfo',
    data: query
  })
}
export function getapprovalreportdatalist (query) {
  return Axios({
    method: 'post',
    url: '/api/getapprovalreportdatalist',
    data: query
  })
}
// 仪表盘数据
export function getapprovaldashboarddatalist (query) {
  return Axios({
    method: 'post',
    url: '/api/getapprovaldashboarddatalist',
    data: query
  })
}
// 考核预览
export function getpdfpreviewbyuser (query) {
  return Axios({
    method: 'post',
    url: '/api/getpdfpreviewbyuser',
    data: query
  })
}

// 获取开启一键提交
export function getapprovaladdconfig (query) {
  return Axios({
    method: 'post',
    url: '/openapi/getapprovaladdconfig',
    data: query
  })
}

// 查询预约时间段
export function getapprovalordertimes (query) {
  return Axios({
    method: 'post',
    url: '/openapi/getapprovalordertimes',
    data: query
  })
}

// 修改当个数据
export function updateapprovingbyfeild (query) {
  return Axios({
    method: 'post',
    url: '/openapi/updateapprovingbyfeild',
    data: query
  })
}

// 定时策略判断是否有权限进入
export function validateapprovaltimeswitch (query) {
  return Axios({
    method: 'post',
    url: '/openapi/validateapprovaltimeswitch',
    data: query
  })
}

// 不需要token定时策略判断是否有权限进入
export function outvalidateapprovaltimeswitch (query) {
  return Axios({
    method: 'post',
    url: '/out/validateapprovaltimeswitch',
    data: query
  })
}

// 附件打包下载
export function filepackdownload (query) {
  return Axios({
    method: 'post',
    url: '/openapi/filepackdownload',
    responseType: 'blob',
    data: query
  })
}

// 导出应用表结构
export function exporttablestructure (query) {
  return Axios({
    method: 'post',
    url: '/api/exporttablestructure',
    responseType: 'blob',
    data: query
  })
}

// 生成查看二维码的密钥
export function lookqrcoreddata (query) {
  return Axios({
    method: 'post',
    url: '/openapi/lookqrcoreddata',
    data: query
  })
}


// 生成数据二维码的密钥
export function qrcoreddata (query) {
  return Axios({
    method: 'post',
    url: '/openapi/qrcoreddata',
    data: query
  })
}

// 阅读量
export function openapiAddreordcount (query) {
  return Axios({
    method: 'post',
    url: '/openapi/addreordcount',
    data: query
  })
}

// 外网阅读量
export function outaddreordcount (query) {
  return Axios({
    method: 'post',
    url: '/out/addreordcount',
    data: query
  })
}

// 内网阅读量
export function getapprovingreordcount (query) {
  return Axios({
    method: 'post',
    url: '/openapi/getapprovingreordcount',
    data: query
  })
}

// 外网阅读量
export function outgetapprovingreordcount (query) {
  return Axios({
    method: 'post',
    url: '/out/getapprovingreordcount',
    data: query
  })
}
// 外网阅读量
export function reducereordcount (query) {
  return Axios({
    method: 'post',
    url: '/openapi/reducereordcount',
    data: query
  })
}
// 外网阅读量
export function outreducereordcount (query) {
  return Axios({
    method: 'post',
    url: '/out/reducereordcount',
    data: query
  })
}

/**
 * 
 * */
export function getsearchbuttoninfo (date) {
  return Axios({
    method: 'post',
    url: '/openapi/getsearchbuttoninfo',
    data: date
  })
}